import React from 'react';
import { useSelector } from 'react-redux';
import Fade from '@material-ui/core/Fade';
import Icons from 'consts/icons';
import ComponentSettings from 'components/user/settings/UserSettings/ComponentSettings';
import Auth from 'auth/Auth';
import ContactPage from 'components/contact/ContactPage';
import EditUser from 'components/user/profile/EditUser/EditUser';
import { SidebarMenuDetailsUseStyles } from './SidebarMenuDetailsUseStyles';

const auth = new Auth();

const SidebarMenuProfileDetails = () => {
  const [items, setItems] = React.useState([]);
  const [details, setDetails] = React.useState(null);
  const classes = SidebarMenuDetailsUseStyles();

  const toggleModal = () => {
    if (details) setDetails(null);
  };

  const useString = () => {
    const lang = useSelector(state => state.language);

    return lang.sidebar.settings;
  };
  const subtitles = useString();

  const handleLogOut = () => {
    auth.unauthenticate();
  };

  React.useEffect(() => {
    setItems([
      {
        name: 'profileSettings',
        icon: <Icons.Profile.ProfileSettings />,
        url: <EditUser />,
      },
      {
        name: 'contact',
        icon: <Icons.Profile.Contact />,
        url: <ContactPage />,
      },
      {
        name: 'logout',
        icon: <Icons.Profile.LogOut />,
        url: '',
      },
    ]);
  }, []);

  return (
    <>
      <div className={`${classes.SidebarMenuDetails}__table`}>
        {items.map(item => (
          <div
            key={item.name}
            className={`${classes.SidebarMenuDetails}__list`}
          >
            <div
              key={item.name}
              className={`${classes.SidebarMenuDetails}__list__item ${
                details === item.name ? 'active' : ''
              }`}
              onClick={
                () => setDetails(details !== item.name ? item.name : null)
                // eslint-disable-next-line react/jsx-curly-newline
              }
              aria-hidden="true"
            >
              <div
                className={`${classes.SidebarMenuDetails}__list__item__icon`}
              >
                {item.icon}
              </div>
              <span
                className={`${classes.SidebarMenuDetails}__list__item__text`}
              >
                {subtitles[`${item.name}_`]}
              </span>
            </div>
          </div>
        ))}
      </div>
      <Fade in={details !== null && details !== 'logout'}>
        <div>
          <ComponentSettings
            items={items}
            details={details}
            setDetails={setDetails}
            toggleModal={toggleModal}
          />
        </div>
      </Fade>
      {details === 'logout' && handleLogOut()}
    </>
  );
};

export default SidebarMenuProfileDetails;
